import axios from 'axios';
import qs from 'qs';
import Vue from "vue";

// 創建axios實例
let accessToken = localStorage.getItem('accessToken')
let baseUrl ='http://127.0.0.1:5000' 
if (process.env.NODE_ENV === 'production'){
    baseUrl = 'https://meetfan.herokuapp.com'
}
const service = axios.create({
    baseURL: baseUrl, // api的base_url
    // withCredentials: true, // 跨域請求時是否發送cookies
    timeout: 5000,// 請求超時設置
    headers: { 'Content-Type': 'application/json', 'Authorization':`Bearer ${accessToken}`},
})

// 請求攔截器
service.interceptors.request.use(config => {
    // 請求前做點什麼？
    // config.withCredentials = true;
    if (!config.data) {
        config.data = {};
    }
    // console.log(config)
    // 設置公共參數
    // console.log(qs.stringify(config.data));

    return config;
}, error => {
    // 處理請求錯誤
    console.log(error); // 用於調試
    return Promise.reject(error);
})

// 響應攔截器
service.interceptors.response.use(response => {
    // let res = respone.data; // 如果返回的結果是data.data的，嫌麻煩可以用這個，return res
    console.log(response.data)
    if(response.data.errCode){
        
        Vue.prototype.$message.error(response.data.errMsg)
    }
    return response.data;
}, error => {
    console.log('error：' + error); // 用於調試
    return Promise.reject(error);
})

export default service;